import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import * as VueGoogleMaps from 'gmap-vue';
import 'whatwg-fetch';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBh-JYNF9mSy1vvJrvbITgSxYMQDfia4qI',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },

  installComponents: true
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
